import { handleCaptchaExpired } from "../../assets/js/handleCaptchaExpired";
import { http } from "../../assets/js/http";
import { captcha } from "../../assets/js/vue/utlis/captcha";

/**
 * Генерация отправка смс кода на переданный номер
 * @see https://wiki.domrf.ru/pages/viewpage.action?pageId=78022852
 * @param {string} phone - номер телефона в формате +7 (000) 000 00 00
 * @param {string} endpoint - id формы. необходимо согласововывать с бэком
 */
export const sendCode = async (phone, endpoint) => {
  const data = {
    jsonrpc: '2.0',
    method: 'sms.sendCode',
    params: {
      'tel': phone,
    },
    id: endpoint,
  };
  await captcha.check();
  return http.post('/rpc/', data, { includeSessionId: true }).catch(handleCaptchaExpired);
}

/**
 * Проверяет высланный смс код
 * @see https://wiki.domrf.ru/pages/viewpage.action?pageId=78022852
 * @param {string} code - код из СМС
 * @param {string} endpoint - id формы. необходимо согласововывать с бэком
 */
export const verifyCode = async (code, endpoint) => {
  const data = {
    jsonrpc: '2.0',
    method: 'sms.verifyCode',
    params: {
      code,
    },
    id: endpoint,
  };
  await captcha.check();
  return http.post('/rpc/', data, { includeSessionId: true })
    .catch(handleCaptchaExpired)
    .then((res) => {
      if (res?.data?.result?.message !== 'Verified') throw new Error('not verified');
    });
}
